<div class="wrapper">
  <div class="overlay" *ngIf="showSpinner">
    <div class="spinner-wrapper">
      <app-spinner>
        <span style="color: #27AE61; font-size: 3em;">
          <i class="fal fa-atom-alt fa-spin"></i>
        </span>
      </app-spinner>
    </div>
  </div>
  <div class="loaded-content" style="padding-left: 15px;" [class.blurred]="showSpinner">
    <div class="row">
      <h3>Open Package</h3>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col">
            <input #ordersearch type="text" [(ngModel)]="orderSearch" style="width: 200px;" />
            <button (click)="handleSearchButton()" style="margin-left: 10px; padding: 4px; width: 35px;">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>

        <div [hidden]="package.Id != null" class="mt-2">
          <span class="text-info" style="font-style: italic">Scan or enter a package identifier to get started</span>
        </div>
        <div class="mt-2" [hidden]="package.Id == null || order?.Accession != null">
          <span class="text-info" style="font-style: italic">Scan or enter a sample serial number from the package</span>
        </div>
        <div class="mt-2" [hidden]="package.Id == null || order?.Accession == null">
          <span class="text-info" style="font-style: italic">Scan the next sample</span>
        </div>
        <div *ngIf="package.Id" class="mt-2" style="font-size: 0.9em">
          <div class="row mt-4">
          </div>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col-4">
                  <label>Delivered</label>
                </div>
                <div class="col-8">
                  {{package.DeliveredDate | date:'short'}}
                </div>
                <div class="col-4">
                  <label>Received By</label>
                </div>
                <div class="col-8">
                  {{package.ReceivedBy}}
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label>From</label>
                </div>
                <div class="col-8">
                  <div class="row">
                    <div class="col-12">
                      {{package.FromName}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      {{package.FromAddress1}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      {{package.FromCity}} {{package.FromState}} {{package.FromZipCode}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <p-button label="  Complete Package"
                            styleClass="p-button-success p-button-raised"
                            (onClick)="completePackage()"
                            icon="fal fa-save">
                  </p-button>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-4" [hidden]="package?.Requisitions.length == 0">
            <p-table #reqlist [columns]="cols" [value]="package.Requisitions" [loading]="loading">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{col.header}} ({{package.Requisitions?.length}})
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                  <td style="cursor: pointer" *ngFor="let col of columns" [ngSwitch]="col.field" (click)="getExistingRequisition(rowData['Accession'])">
                    <span class="mr-2" style="font-size: 1.2em" *ngIf="rowData['StatusLevel'] == 3" title="Rejected">
                      <i style="--fa-primary-color: gray; --fa-secondary-color: red; --fa-secondary-opacity: 1.0;" class="fad fa-copy"></i>
                    </span>
                    <span class="mr-2" style="font-size: 1.2em" *ngIf="rowData['StatusLevel'] == 2" title="Exceptions">
                      <i style="--fa-primary-color: gray; --fa-secondary-color: yellow; --fa-secondary-opacity: 1.0;" class="fad fa-copy"></i>
                    </span>
                    <span class="mr-2" style="font-size: 1.2em" *ngIf="rowData['StatusLevel'] == 1" title="Accepted">
                      <i style="--fa-primary-color: gray; --fa-secondary-color: green; --fa-secondary-opacity: 1.0;" class="fad fa-copy"></i>
                    </span>
                    <span *ngSwitchDefault>{{rowData[col.field]}}</span>

                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
      <div class="col-9" *ngIf="package?.Id">
        <form #sampleForm="ngForm">
          <div style="margin: auto; width: 800px;" *ngIf="order?.Accession">
            <div class="row">
              <div class="col-12">
                <span class="float-right">
                  <p-button label="  Delete" class="p-button-secondary p-button-raised " (onClick)="deleteClicked()" icon="pi pi-trash"></p-button>
                </span>
              </div>
            </div>
            <div style="min-height: 125px" class="alert alert-danger" role="alert" [hidden]="!order?.IsRejected">
              <div class="row h2">
                <div class="col-12 text-center">
                  <span>
                    <b>REJECT</b>
                  </span>
                </div>
              </div>
              <div class="row h3" style="margin-top: 20px">
                <div class="col-12 text-center">
                  Put the sample in the reject tote
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <div *ngFor="let reject of order.RequisitionRejections">
                    {{reject.RejectionTypeName}}
                  </div>
                </div>
              </div>

            </div>
            <div style="min-height: 125px" class="alert alert-warning" role="alert" [hidden]="order?.IsRejected || !order?.HasExceptions">
              <div class="row h3">
                <div class="col-6">
                  <span>
                    <b>EXCEPTION</b>
                  </span>
                </div>
                <div class="col-6">
                  <div class="grid" *ngFor="let exception of order?.Exceptions">
                    <div class="col-12">
                      {{exception.IssueDescription}}
                    </div>
                  </div>
                </div>

              </div>
              <div class="row" style="margin-top: 25px">
                <div class="col-12 text-center" [hidden]="order.SpecimenSerialNumber">
                  Verify the Sample Type and then put the sample in the exception tote
                </div>
                <div class="col-12 text-center" [hidden]="!order.SpecimenSerialNumber">
                  Put the sample in the exception tote
                </div>
              </div>
            </div>
            <div style="min-height: 125px" class="alert alert-success h3" role="alert" [hidden]="order?.IsRejected || order?.HasExceptions">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-4">
                        <b>ACCEPTED: </b>
                      </div>
                      <div class="col-md-4">
                        <div class="row" *ngFor="let x of order.RequisitionTests">
                          <div class="col-12">
                            <b>{{x.LabTestName}}</b>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4"></div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">

                      </div>
                      <div class="col-md-4">

                      </div>
                      <div class="col-md-4"></div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">

                      </div>
                      <div class="col-md-4">
                        send to lab
                      </div>
                      <div class="col-md-4"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-5">
                <div style="font-size: 1.2em; font-weight: bold;" class="col-12">
                  <label>Accession:</label> {{order?.Accession}}
                </div>
              </div>
              <div class="col-7">
                <div class="row">
                  <div class="col-4">
                    <label class="float-right">Sample Type:</label>
                  </div>
                  <div class="col-8">
                    <div [hidden]="order == null">
                      {{order.SpecimenTypeCode}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <p-button label="  Reject for LIT"
                          styleClass="p-button-danger p-button-lg p-button-raised"
                          (onClick)="rejectClicked()"
                          icon="far fa-thumbs-down"
                          [hidden]="order.IsLIT"
                          [disabled]="rejectDisabled">
                </p-button>
                <p-button label="Undo LIT"
                          styleClass="p-button-danger p-button-lg p-button-raised"
                          (onClick)="rejectClicked()"
                          icon="far fa-thumbs-up"
                          [hidden]="!order.IsLIT"
                          [disabled]="rejectDisabled">
                </p-button>
              </div>
            </div>
            <div *ngIf="order!= null">
              <div style="font-size: 0.9em">
                <div class="row mt-2 mb-2 section">
                  <div class="col-12">
                    <h4>Patient</h4>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <label>Birthdate:</label> {{order?.BirthDate | date:'MM/dd/yyyy'}}
                  </div>
                  <div class="col-3">
                    <label>First Name:</label> {{order?.FirstName}}
                  </div>
                  <div class="col-3">
                    <label>Last Name:</label> {{order?.LastName}}
                  </div>
                  <div class="col-3">
                  </div>
                </div>

                <div class="row mt-2 mb-2 section">
                  <div class="col-12">
                    <h4>Provider Information</h4>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <label>Client:</label> {{order?.ClientName}}
                  </div>
                  <div class="col-6">
                    <label>Provider:</label> {{order?.ProviderNPI}} - {{order?.ProviderName}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label>Facility:</label>&nbsp;{{order?.FacilityCode}}&nbsp;{{order?.FacilityName}}
                  </div>
                  <div class="col-6">
                  </div>
                </div>

                <div class="row mt-2 mb-2 section">
                  <div class="col-12">
                    <h4>Test Information</h4>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <label>Collection Date</label>
                  </div>
                  <div class="col-3">
                    <label>Serial Number</label>
                  </div>
                  <div class="col-6">
                    <label>Test</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    {{order?.DateOfService | date:'MM/dd/yyyy h:mm:ss a'}}
                  </div>
                  <div class="col-3">
                    {{order?.Accession}}
                  </div>
                  <div class="col-6">
                    <div class="row" *ngFor="let x of order.RequisitionTests">
                      <div class="col-12 pl-4">
                        {{x.LabTestName}} - {{x.LabTestDescription}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>

<p-dialog [(visible)]="showNameConfirmDialog" modal="true" [style]="{width: '850px'}" position="top" [closable]="false" [closeOnEscape]="false">
  <ng-template #header>
    <h3>Confirm Specimen, Name and DOB </h3> Sample {{order.Accession}}
  </ng-template>
  <div class="fluid grid">
    <div class="h4 col-12 formgroup-inline">
      <div class="h4 col-12 formgroup-inline">

        <div class="col-6">
          <div class="grid">
            <div class="col-12">
              Specimen: {{getSpecimenTypeNameByCode(order?.SpecimenTypeCode)}}
            </div>
            <div class="h6 col-12" *ngIf="order.PatientSampleObserved != null && order.PatientSampleObserved != order.SpecimenTypeCode">
              Observed: {{getSpecimenTypeNameByCode(order.PatientSampleObserved)}}
            </div>
          </div>
        </div>
        <div class="col-6 formgroup-inline">
          <div class="field-radiobutton">
            <p-radioButton name="specimenMatch" styleClass="radio-style" inputId="specimenMatch1"
                           [ngClass]="{'selectedgreen':order.SpecimenTypeMatch}" [value]="true" [(ngModel)]="order.SpecimenTypeMatch" label="Matches" (onClick)="changeSpecimenType($event)">
            </p-radioButton>
            <label for="specimenMatch1" class="ml-2">Matches</label>
          </div>
          <div class="field-radiobutton">
            <p-radioButton name="specimenMatch" styleClass="radio-style" inputId="specimenMatch2"
                           [ngClass]="{'selectedexception':!order.SpecimenTypeMatch}" [value]="false" [(ngModel)]="order.SpecimenTypeMatch" label="Does not match" (onClick)="changeSpecimenType($event)">
            </p-radioButton>
            <label for="specimenMatch2" class="ml-2">Does not match</label>
          </div>
        </div>
      </div>
    </div>

    <div class="h4 col-12 formgroup-inline">
      <div class="h4 col-12 formgroup-inline">
        <div class="col-6 formgroup-inline">Name: {{order.FirstName}} {{order.LastName}}</div>
        <div class="col-6 formgroup-inline">
          <div class="field-radiobutton">
            <p-radioButton name="nameMatch" styleClass="radio-style" inputId="nameMatch1"
                           [ngClass]="{'selectedgreen':order.NameMatch}" [value]="true" [(ngModel)]="order.NameMatch" label="Matches">
            </p-radioButton>
            <label for="nameMatch1" class="ml-2">Matches</label>
          </div>
          <div class="field-radiobutton">
            <p-radioButton name="nameMatch" styleClass="radio-style" inputId="nameMatch2"
                           [ngClass]="{'selectedexception': order.NameMatch!= null && !order.NameMatch}" [value]="false" [(ngModel)]="order.NameMatch" label="Does not match">
            </p-radioButton>
            <label for="nameMatch2" class="ml-2">Does not match</label>
          </div>
        </div>
      </div>

    </div>
    <div class="h4 col-12 formgroup-inline">
      <div class="h4 col-12 formgroup-inline">
        <div class="col-6 formgroup-inline">Birth Date: {{order.BirthDate | date:'MM/dd/yyyy' }}</div>
        <div class="col-6 formgroup-inline">
          <div class="field-radiobutton">
            <p-radioButton name="birthDateMatch" styleClass="radio-style" inputId="birthDateMatch1"
                           [ngClass]="{'selectedgreen':order.BirthDateMatch}" [value]="true" [(ngModel)]="order.BirthDateMatch" label="Matches">
            </p-radioButton>
            <label for="birthDateMatch1" class="ml-2">Matches</label>
          </div>
          <div class="field-radiobutton">
            <p-radioButton name="birthDateMatch" styleClass="radio-style" inputId="birthDateMatch2"
                           [ngClass]="{'selectedexception':order.BirthDateMatch!= null && !order.BirthDateMatch}" [value]="false" [(ngModel)]="order.BirthDateMatch" label="Does not match">
            </p-radioButton>
            <label for="birthDateMatch2" class="ml-2">Does not match</label>
          </div>
        </div>
      </div>
    </div>


  </div>
  <div class="flex justify-content-center w-full">
    <p-button (onClick)="cancelNameConfirmDialog()" icon="pi pi-trash" label="Cancel" class="m-2"></p-button>
    <p-button (onClick)="closeNameConfirmDialog()" icon="pi pi-check" label="Next" class="m-2" [disabled]="isNextDisabled()"></p-button>
  </div>
</p-dialog>

<p-dialog [(visible)]="showSpecimenSelectDialog" modal="true" [style]="{width: '800px'}" position="top" [closable]="false" [closeOnEscape]="false">
  <ng-template #header>
    <h3>Select Specimen </h3>
  </ng-template>
  <div class="p-fluid grid">
    <div class="h4 col-12 p-formgroup-inline">
      <div class="h4 col-12 p-formgroup-inline">
        <div class="col-6 p-formgroup-inline">
          <div col-md-12>
            <div *ngFor="let specimenType of specimensAvailableList();let i = index;" class="p-field-radiobutton">
              <div class="p-field-radiobutton" *ngIf="specimenType.Code != order.SpecimenTypeCode">
                <p-radioButton inpudIt="specimenType.Code" name="category" [value]="specimenType.Code" [(ngModel)]="order.PatientSampleObserved" [disabled]="specimenType.Code === 'R'" (onClick)="closeSpecimenConfirmDialog(false)"> </p-radioButton>
                <label for="{{specimenType.Code}}">{{specimenType.Name}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="grid p-jc-center">
    <p-button (onClick)="closeSpecimenConfirmDialog(true)" icon="pi pi-trash" label="Cancel" class="p-m-2"></p-button>
  </div>
</p-dialog>


<p-dialog [(visible)]="showDuplicateDialog" modal="true" [style]="{width: '800px'}" position="top" [closable]="false" [closeOnEscape]="false">
  <ng-template #header>
    <h3 *ngIf="!order.IsPatientMismatch">Duplicate</h3>
    <h3 *ngIf="order.IsPatientMismatch">Label Mismatch</h3>
    Sample {{order.SpecimenSerialNumber}}
  </ng-template>
  <div [hidden]="printLabelOption">
    <div class="p-fluid">
      A new number must be assigned to this sample.<br /><br />
      <div [hidden]="newSerial != null">
        Scan the new label (or enter it and press the search button) to verify the label is ok to use.<br />
      </div>
      <div [hidden]="newSerial == null || newSerialVerified == null || (newSerial && newSerialVerified)">
        Try a different label, the one you entered has already been used.<br />
      </div>
      <div class="p-inputgroup">
        <span class="p-input-icon-right">
          <input #rebarCode id="rebarCode" type="text" focus="true" pInputText [(ngModel)]="newSerial" style="margin-right: 10px; width: 240px;" />
          <i class="pi pi-check" [hidden]="newSerialVerified == null || newSerialVerified == false"></i>
          <i class="pi pi-times" [hidden]="newSerialVerified == null || newSerialVerified == true"></i>
        </span>
        <button (click)="verifyNewAccession()" style="margin-left: 10px; padding: 4px; width: 35px;">
          <i class="fa fa-search"></i>
        </button>
      </div>
      <div [hidden]="!newSerialVerified">
        Apply the new label to the sample, making sure to cover the existing bar code. Press the Label Is Applied button when complete.<br />
      </div>
    </div>

    <div class="grid p-jc-center margin-top-20">
      <p-button (onClick)="cancelDuplicateDialog()" icon="pi pi-trash" label="Cancel" class="p-m-2"></p-button>
      <p-button (onClick)="closeDuplicateDialog()" icon="pi pi-check" label="Label Is Applied" class="p-m-2" [disabled]="!newSerialVerified"></p-button>
    </div>
  </div>
  <div [hidden]="!printLabelOption">
    <div class="p-fluid grid">
      This serial number has already been processed. A new number must be assigned to this sample.<br /><br />
      Press the Print button to print a new label for it.<br />
      Apply the label on the sample so that it covers the existing bar code, and then press the Label Is Applied button<br />
    </div>
    <div class="print-container">
      <div id="label" style="min-height: 150px;">
        <div>
          {{order.FirstName}} {{order.LastName}} {{order.BirthDate | date:'MM/dd/yyyy'}}
        </div>
        <div>
          <ngx-barcode6 [bc-value]="order.Accession" [bc-display-value]="true" [bc-width]="2" [bc-height]="30" [bc-font-size]="12"></ngx-barcode6>
        </div>
      </div>
    </div>
    <div class="grid p-jc-center">
      <button class="navbutton" printSectionId="label" ngxPrint><i class="fa fa-print"></i> Print Label</button>
      <button class="navbutton" (click)="closeDuplicateDialog()"><i class="fa fa-check"></i> Label Is Applied</button>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="showPaperReqDialog" modal="true" [style]="{width: '500px'}" [closable]="false" [closeOnEscape]="false">
  <ng-template #header>
    Paper Requisition Client - {{package?.Client?.Name}}
  </ng-template>
  <div>
    This client is configured for Paper Requisitions and cannot be processed in LabTek21.<br />
    This package must be processed in QuickBase.
  </div>
  <div class="grid p-jc-center">
    <p-button (onClick)="closePaperReqDialog()" icon="pi pi-check" label="Ok" class="p-m-2"></p-button>
  </div>
</p-dialog>
